<template>
  <div class="card card-custom">
    <div class="card-body p-0">
      <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
        <div class="col-xl-12 col-xxl-12">
          <h2 class="text-center pb-10">Formulaire de création d'un droit utilisateur</h2>
          <FormUserRight v-model="formData" @submit="submit"></FormUserRight>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import FormUserRight from "@/components/admin/userRight/forms/formUserRight.vue";

import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "addUserRight",
  data: () => ({
    formData: {
      name: "",
      clientId: null,
      comment: "",
      themes: [],
    },
  }),
  props:{
    client: Object,
  },
  components: {
    FormUserRight,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionClients" },
      { title: "Gestion des comptes des droits utilisateurs" },
      { title: "Créer un droit utilisateur" },
    ]);
  },
  methods: {
      submit: async function() {
          
      try {
        await Api.post("user_rights", {
          name: this.formData.name,
          client: this.formData.clientId,
          comment: this.formData.comment,
          themes: this.formData.themes.map(t=>t['@id'])
        });
        
         Swal.fire({
          title: "",
          text: "Le droit utilisateur a été crée.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
        });
        this.$router.push({ name: 'gestionClients', query: {
                  selected: 'tab-userRights',
                },})
      } catch (error) {
        //Dans le cas où la requête à échoué.
        Swal.fire({
          title: "",
          text: "Une erreur est survenue lors de la création du droit utilisateur",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
        return;
      }

    },
  }
};
</script>
